module.exports = __webpack_public_path__ + "static/media/Motivo2.011f9817.png";